import Vue from 'vue'
import slugify from '../utils/slugify'

/**
 * Vue store
 * https://vuejs.org/v2/api/#Vue-observable
 */
export const store = Vue.observable({
  filters: [],
  showFilterDrawer: false,
  showCartDrawer: false,

  products: [],
  categories: [],
  species: [],
  therapies: [],

  resultsCount: 0,
  searchParams: '',
  filterParams: '',
})

/**
 * Store mutations
 */
export const mutations = {
  setProducts: products => store.products = products,
  setCategories: categories => store.categories = categories,
  setSpecies: species => store.species = species,
  setTherapies: therapies => store.therapies = therapies,
  setSearchParams: params => store.searchParams = params,
  setFilterParams: params => store.filterParams = params,
  clearFilters: function() {
    store.categories.forEach(category => category.active = false)
    store.species.forEach(specie => specie.active = false)
    store.therapies.forEach(therapy => therapy.active = false)
    store.searchParams = ''
    store.filterParams = ''
  },
  setFilters: filters => store.filters = filters,
  toggleFilter: filter => filter.active = !filter.active,
  toggleFilterDrawer: () => store.showFilterDrawer = !store.showFilterDrawer,
}

/**
 * Store getters
 */
export const getters = {
  activeCategories: () => store.categories.filter(item => item.active),
  activeSpecies: () => store.species.filter(item => item.active),
  activeTherapies: () => store.therapies.filter(item => item.active),
  activeQuery: () => !store.searchParams ? [] : [
    {
      id: -1,
      name: store.searchParams,
      slug: slugify(store.searchParams),
      active: true
    }
  ],
  activeFilters: function() {
    return [
      ...this.activeCategories(),
      ...this.activeSpecies(),
      ...this.activeTherapies(),
    ]
  },
  productsByCategoryId: id => store.products.filter(product => product.categories.includes(id)),
  products: function(id) {
    let products = !!id ? store.products.filter(product => product.categories.includes(id)) : store.products
    const params = store.searchParams.length === 0 ? [] : store.searchParams.split('+')
    if (this.activeFilters().length === 0 && params.length === 0) return products

    if (this.activeCategories().length > 0) products = filterProductsByActiveCategories(products)
    if (this.activeSpecies().length > 0) products = filterProductsByActiveSpecies(products)
    if (this.activeTherapies().length > 0) products = filterProductsByActiveTherapies(products)
    if (params.length > 0) products = filterProductsByParams(products, params)


    return products
  }
}

/** Helpers */
const filterProductsByActiveCategories = products => {
  const activeCategories = getters.activeCategories()
  return products.filter(product => {
    if (activeCategories.filter(category => product.categories.indexOf(category.id) !== -1).length > 0) {
      return product
    }
  })
}

const filterProductsByActiveSpecies = products => {
  const activeSpecies = getters.activeSpecies()
  return products.filter(product => {
    if (activeSpecies.filter(specie => product.species.indexOf(specie.id) !== -1).length > 0) {
      return product
    }
  })
}

const filterProductsByActiveTherapies = products => {
  const activeTherapies = getters.activeTherapies()
  return products.filter(product => {
    if (activeTherapies.filter(therapy => product.therapies.indexOf(therapy.id) !== -1).length > 0) {
      return product
    }
  })
}

const filterProductsByParams = (products, params) => {
    return products.filter(product => {
        if (params.filter(param => {
            const regex = new RegExp(param, 'i')
            if (product.name.match(regex) || product.description.match(regex) || product.metaKeywords.match(regex)) return param
        }).length > 0) {
            return product
        }
    })
}